// A histogram's edge buckets are labelled "< 10" / "> 1000". Number, currency and percentage
// formatters can't format that whole string (they return "", "$NaN" or "n/a"), so format the number
// after the prefix and keep the prefix. Anything else (e.g. date labels like "< 1/2020") is passed
// to the formatter unchanged.
const EDGE_LABEL = /^([<>]) (.+)$/;

module.exports = function formatHistogramBucketLabel(label, formatValue) {
  const match = typeof label === "string" && EDGE_LABEL.exec(label);
  if (match) {
    const bound = Number(match[2]);
    if (match[2].trim() !== "" && !Number.isNaN(bound)) {
      return `${match[1]} ${formatValue(bound)}`;
    }
  }
  return formatValue(label);
};
